import apiClient from "@/axios";

export const getAllList = async (page = 1, sort = 'created_at', order = 'asc', platformId = null, searchQuery = null) => {
  const response = apiClient.post("/user/list/developer/all",{
    page: page,
    sort: sort,
    order: order,
    platformId: platformId,
    searchQuery: searchQuery
  });
  return response;
};

export const getDeveloperList = async (developerId) => {
  const response = apiClient.post("/user/list/developer/developer-lists", {
    developerId: developerId,
  });
  return response;
};

export const getSavedList = async (developerId) => {
  const response = apiClient.post("/user/list/developer/saved-lists", {
    developerId: developerId,
  });
  return response;
};

export const getListDevelopers = async (listId) => {
  const response = apiClient.post("/user/list/developer/list-developers", {
    listId: listId,
  });
  return response;
};

export const addDeveloperToList = async (developerId, listId) => {
  const response = apiClient.post("/user/list/developer/add", {
    developerId: developerId,
    listId: listId,
  });
  return response;
};

export const AddDeveloperToMultipleLists = async (developerId, listIds) => {
  const response = apiClient.post("/user/list/developer/add-to-multiple-lists", {
    developerId: developerId,
    listIds: listIds,
  });
  return response;
};

export const removeDeveloperFromList = async (developerId, listId) => {
  const response = apiClient.post("/user/list/developer/remove", {
    developerId: developerId,
    listId: listId,
  });
  return response;
};
